module.exports = __webpack_public_path__ + "img/sjj.81fae906.png";